import {
  BodyText,
  Card,
  Flex,
  Heading,
  Link,
} from '@utilitywarehouse/hearth-react';
import { ChevronRightSmallIcon } from '@utilitywarehouse/hearth-react-icons';
import SpotBoilerLight from '@utilitywarehouse/hearth-svg-assets/lib/spot-boiler-light.svg';
import { useNavigate } from 'react-router-dom';

import { EXTERNAL_LINKS } from '@constants/externalLinks';
import { paths } from '@constants/paths';
import { useBundleBasket } from '@hooks/useBundleBasket';
import { isAmountCredit } from '@utils/price';

import './styles.scss';

const BHC_DISCOUNT_DURATION_MONTHS = 3;
const FALLBACK_PROMO_VALUE = '25.00';

const BhcPromoBanner = () => {
  const navigate = useNavigate();
  const { basket } = useBundleBasket({});

  const discount = basket?.insurance.boilerInsurance?.discount;
  const regularPrice =
    discount && discount?.credit && isAmountCredit(discount?.credit)
      ? discount.credit.amount
      : FALLBACK_PROMO_VALUE;
  const promoDuration =
    basket?.insurance.boilerInsurance?.discount?.creditFrequency ??
    BHC_DISCOUNT_DURATION_MONTHS; // default to 3 months if not specified

  const handlePromoCardClick = () => {
    navigate(paths.bhc);
  };

  return (
    <Card className="bhc-promo-banner__card" variant="emphasis">
      <img src={SpotBoilerLight} alt="Bundle Bot" />
      <Flex
        direction="column"
        spacing="md"
        className="bhc-promo-banner__content"
      >
        <Heading>{promoDuration} months free boiler cover.</Heading>
        <BodyText>
          Take the hassle out of boiler breakdowns with our five star-rated
          cover. Get your first {promoDuration} months free, then just £
          {regularPrice}/month.{' '}
          <Link
            href={EXTERNAL_LINKS.bhcPromoTerms}
            target="_blank"
            rel="noopener noreferrer"
          >
            <strong>
              <u>Terms apply.</u>
            </strong>
          </Link>
        </BodyText>
        <Link asChild onClick={handlePromoCardClick}>
          <button type="button">
            Find out more
            <ChevronRightSmallIcon />
          </button>
        </Link>
      </Flex>
    </Card>
  );
};

export default BhcPromoBanner;
